import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";

/**
 * Renders a CSS grid of standard labeled text inputs from a field-definition array.
 *
 * Props:
 *   fields         - Array<{
 *                      name: string,
 *                      label: string,
 *                      colSpan?: 2,        // spans both columns when 2
 *                      inputMode?: string, // e.g. "numeric" for number-pad on mobile
 *                    }>
 *   control        - react-hook-form control
 *   labelClassName - optional className for every FormLabel in the grid
 *   gridClassName  - className on the wrapping div
 *                    (default: "grid grid-cols-2 gap-4")
 */
export function FormFieldGrid({
  fields,
  control,
  labelClassName,
  gridClassName = "grid grid-cols-1 sm:grid-cols-2 gap-4",
}) {
  return (
    <div className={gridClassName}>
      {fields.map(({ name, label, colSpan, inputMode }) => (
        <FormField
          key={name}
          control={control}
          name={name}
          render={({ field }) => (
            <FormItem className={colSpan === 2 ? "col-span-2" : ""}>
              <FormLabel className={labelClassName}>{label}</FormLabel>
              <FormControl>
                <Input {...field} inputMode={inputMode} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      ))}
    </div>
  );
}
